import type { SVGProps } from 'react';

type SortOrder = 'ascend' | 'descend' | null;

type TableSortIconProps = SVGProps<SVGSVGElement> & {
  sortOrder?: SortOrder;
  activeColor?: string;
  inactiveColor?: string;
};

export const TableSortIcon = ({
  sortOrder,
  activeColor = '#1E1E1E',
  inactiveColor = '#777777',
  ...props
}: TableSortIconProps) => {
  const upStroke = sortOrder === 'ascend' ? activeColor : inactiveColor;
  const downStroke = sortOrder === 'descend' ? activeColor : inactiveColor;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* up */}
      <path
        d="M5 6L8 3L11 6"
        stroke={upStroke}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* down */}
      <path
        d="M5 10L8 13L11 10"
        stroke={downStroke}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
